export default "__VITE_ASSET__BDxgvPcU__"